import { render } from "./LoginForm.vue?vue&type=template&id=66293632"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=66293632&lang=scss"

import exportComponent from "C:\\Users\\stall\\Documents\\Projects\\Web Apps\\Small Projects\\gmscoreboard2021-primevue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__